import { Suspense } from 'react';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute = ({ children }: PublicRouteProps) => (
  <Suspense fallback={null}>{children}</Suspense>
);

export default PublicRoute;
